/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import LegalLayout from "./LegalLayout";
import Seo, { breadcrumbTrail } from "../components/dmb/Seo";

export default function Confidentialite() {
    return (
        <LegalLayout
            testid="confidentialite"
            kicker="Informations légales"
            title="Politique de confidentialité"
            lastUpdate="16 octobre 2026"
        >
            <Seo
                title="Politique de confidentialité | DMB Partners"
                description="Comment DMB Partners collecte, utilise et conserve vos données personnelles, et comment exercer vos droits (accès, rectification, effacement, opposition)."
                path="/confidentialite"
                jsonLd={breadcrumbTrail([
                    { name: "Accueil", path: "/" },
                    { name: "Politique de confidentialité", path: "/confidentialite" },
                ])}
            />
            <p>
                DMB PARTNERS attache une importance particulière à la protection
                de vos données personnelles. La présente politique explique
                quelles données nous collectons sur{" "}
                <a href="https://www.dmbpartners.fr">www.dmbpartners.fr</a>,
                pourquoi, combien de temps nous les conservons et comment exercer
                vos droits, conformément au Règlement (UE) 2016/679 (RGPD) et à
                la loi n° 78-17 du 6 janvier 1978 modifiée.
            </p>

            <h2>1. Responsable de traitement</h2>
            <p>
                DMB PARTNERS, SAS au capital de 1 000 euros, RCS Paris 928 053
                487, 149 avenue du Maine, 75014 Paris. Contact :{" "}
                <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a>.
            </p>

            <h2>2. Données collectées</h2>
            <ul>
                <li>
                    <strong>Via le formulaire de contact :</strong> nom de
                    l'entreprise, tranche de chiffre d'affaires, nature du besoin,
                    nom et prénom, fonction, adresse e-mail, numéro de téléphone,
                    contenu de votre message.
                </li>
                <li>
                    <strong>Données techniques :</strong> adresse IP et journaux
                    de connexion conservés par notre hébergeur pour la sécurité du
                    Site.
                </li>
                <li>
                    <strong>Cookies et traceurs :</strong> voir la{" "}
                    <Link to="/cookies">politique cookies</Link>.
                </li>
            </ul>
            <p>
                Nous ne collectons aucune donnée sensible et n'utilisons pas vos
                données pour une prise de décision automatisée.
            </p>

            <h2>3. Finalités et bases légales</h2>
            <table>
                <thead>
                    <tr>
                        <th>Finalité</th>
                        <th>Base légale</th>
                        <th>Durée de conservation</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Répondre à votre demande et vous adresser un accusé de réception</td>
                        <td>Mesures précontractuelles prises à votre demande</td>
                        <td>3 ans à compter du dernier contact</td>
                    </tr>
                    <tr>
                        <td>Suivi de la relation commerciale avec les dirigeants et entreprises</td>
                        <td>Intérêt légitime de DMB PARTNERS</td>
                        <td>3 ans à compter du dernier contact</td>
                    </tr>
                    <tr>
                        <td>Sécurité et bon fonctionnement du Site</td>
                        <td>Intérêt légitime de DMB PARTNERS</td>
                        <td>12 mois maximum</td>
                    </tr>
                </tbody>
            </table>

            <h2>4. Destinataires</h2>
            <p>
                Vos données sont destinées exclusivement aux associés de DMB
                PARTNERS. Elles ne sont ni cédées, ni louées, ni vendues. Elles
                sont hébergées et traitées, pour notre compte, par nos
                sous-traitants techniques : <strong>Emergent Labs Inc.</strong>{" "}
                (hébergement du Site et de la base de données) et{" "}
                <strong>Resend Inc.</strong> (envoi des e-mails d'accusé de
                réception), situés aux États-Unis.
            </p>

            <h2>5. Transferts hors de l'Union européenne</h2>
            <p>
                Les transferts de données vers ces sous-traitants situés aux
                États-Unis sont encadrés par les garanties appropriées prévues
                par le RGPD, notamment les clauses contractuelles types adoptées
                par la Commission européenne.
            </p>

            <h2>6. Vos droits</h2>
            <p>
                Vous disposez d'un droit d'accès, de rectification, d'effacement,
                de limitation, d'opposition et de portabilité de vos données,
                ainsi que du droit de définir des directives relatives à leur
                sort après votre décès. Lorsque le traitement repose sur votre
                consentement, vous pouvez le retirer à tout moment.
            </p>
            <p>
                Pour exercer ces droits, écrivez à{" "}
                <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a> ou
                à DMB PARTNERS, 149 avenue du Maine, 75014 Paris. Nous répondons
                dans un délai d'un mois. Vous pouvez également introduire une
                réclamation auprès de la CNIL (
                <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>).
            </p>

            <h2>7. Sécurité</h2>
            <p>
                Les échanges avec le Site sont chiffrés (HTTPS). L'accès aux
                demandes reçues est limité aux associés de DMB PARTNERS.
            </p>
        </LegalLayout>
    );
}
